import { useState, useEffect } from 'react';
import {
  getCandidateActivityLogs,
  ActivityLogSearchResponse,
  ActivityLogSearchRequest,
} from 'wisestep-api';

const useActivityLog = (payLoad: ActivityLogSearchRequest) => {
  const [activityLog, setActivityLogs] = useState<ActivityLogSearchResponse[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      if (payLoad.candidateId) {
        setActivityLogs([]);
        const response = await getCandidateActivityLogs(payLoad);
        setActivityLogs(response.data?.content);
        setLoading(false);
      }
    })();
  }, [payLoad]);

  return { activityLog, loading };
};

export default useActivityLog;
